import { useQuery, UseQueryOptions } from 'react-query';
import { ChannelType } from 'api-data-types';
import requester from 'utils/requester';
import api from 'config/api';

const key = 'CHANNELS';

const DEFAULT_OPTIONS = {};

type LoadType = { offset?: number; all?: boolean };

const load = async ({ offset, all }: LoadType) => {
  const $offset = Number.isInteger(offset) ? offset : 0;
  const { data } = await requester({
    method: 'get',
    url: `${api.host}${api.endpoints.assets}`,
    params: {
      'type[eq]': 'channel',
      $expand: 'resources(url),entitlement,favorite,bookmark,genres',
      $orderby: 'lcn',
      $limit: all ? null : 24,
      $offset,
    },
  });

  return data;
};

const useLoadChannels = (
  params: LoadType = {},
  options: UseQueryOptions<ChannelType[], unknown, ChannelType[]> = {},
) => {
  return useQuery<ChannelType[], Error>([key, params.offset], () => load(params), {
    ...DEFAULT_OPTIONS,
    ...options,
  });
};

export default useLoadChannels;
